module.exports = __webpack_public_path__ + "static/media/new-step-indicator-1.826e0b0f.svg";